// Reducer function to manage user-related state based on dispatched actions
export const userReducer = (state, action) => {
  switch (action.type) {
    // Handles user signup and updates the state with new user data
    case "signup": {
      const { username, email, password, fname, lname } = action.payload;

      const newState = {
        ...state,
        username: username,
        email: email,
        password: password,
        fname: fname,
        lname: lname,
      };

      return newState;
    }

    // Handles user login by updating the state with user details
    case "login":
      return {
        ...state,
        ...action.payload,
      };

    // Handles user logout by resetting the state to initial values
    case "logout":
      return {
        username: "",
        email: "",
        password: "",
        cart: {
          products: [],
          amount: 0,
          total: 0,
        },
        purchasedProducts: [],
      };

    // Adds a product to the cart, increasing its amount if already exists
    case "addToCart": {
      const existingProduct = state.cart.products.find(
        (p) => p.id === action.payload.id
      );

      let newProducts;
      if (existingProduct) {
        newProducts = state.cart.products.map((p) =>
          p.id === action.payload.id ? { ...p, amount: p.amount + 1 } : p
        );
      } else {
        newProducts = [
          ...state.cart.products,
          { ...action.payload, amount: 1 },
        ];
      }

      const { amount, total } = updateTotal(newProducts);

      return {
        ...state,
        cart: {
          products: newProducts,
          amount,
          total,
        },
      };
    }

    // Removes a product from the cart
    case "removeFromCart": {
      const newProducts = state.cart.products.filter(
        (product) => product.id !== action.payload.id
      );

      const { amount, total } = updateTotal(newProducts);

      return {
        ...state,
        cart: {
          products: newProducts,
          amount,
          total,
        },
      };
    }

    // Increases the quantity of a product in the cart
    case "increaseAmount": {
      const updatedProducts = state.cart.products.map((product) =>
        product.id === action.payload.id
          ? { ...product, amount: product.amount + 1 }
          : product
      );
      const { amount, total } = updateTotal(updatedProducts);
      return {
        ...state,
        cart: {
          products: updatedProducts,
          amount: amount,
          total: total,
        },
      };
    }

    // Decreases the quantity of a product in the cart
    case "decreaseAmount": {
      const updatedProducts = state.cart.products.map((product) =>
        product.id === action.payload.id
          ? { ...product, amount: product.amount - 1 }
          : product
      );
      const { amount, total } = updateTotal(updatedProducts);
      return {
        ...state,
        cart: {
          products: updatedProducts,
          amount: amount,
          total: total,
        },
      };
    }

    // Handles the checkout process, moving items from the cart to purchased products
    case "checkout":
      return {
        ...state,
        purchasedProducts: [...state.purchasedProducts, ...action.payload],
        cart: {
          products: [],
          amount: 0,
          total: 0,
        },
      };

    // Updates user information when edited
    case "editUserInfo":
      return {
        ...state,
        ...action.payload,
      };

    // Default case returns the current state if action type is not recognized
    default:
      return state;
  }
};

// Helper function to calculate the total price and total quantity of items in the cart
const updateTotal = (products) => {
  let amount = 0;
  let total = 0;
  products.forEach((product) => {
    amount += product.amount;
    total += product.price * product.amount;
  });
  return { amount, total };
};
